import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_stepper_window_item = _resolveComponent("v-stepper-window-item")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_stepper_window = _resolveComponent("v-stepper-window")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.showWizard,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showWizard) = $event)),
    persistent: "",
    "max-width": "800px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createElementVNode("span", { class: "text-h5" }, "Agent Wizard", -1)
            ])),
            _: 1,
            __: [15]
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_stepper, {
                modelValue: _ctx.currentStep,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentStep) = $event)),
                "alt-labels": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_stepper_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_stepper_item, {
                        complete: _ctx.currentStep > 1,
                        editable: _ctx.currentStep > 1,
                        value: 1,
                        title: "Provider",
                        color: "primary"
                      }, null, 8, ["complete", "editable"]),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_stepper_item, {
                        complete: _ctx.currentStep > 2,
                        editable: _ctx.currentStep > 2,
                        value: 2,
                        title: "Model",
                        color: "primary"
                      }, null, 8, ["complete", "editable"]),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_stepper_item, {
                        complete: _ctx.currentStep > 3,
                        editable: _ctx.currentStep > 3,
                        value: 3,
                        title: "Details",
                        color: "primary"
                      }, null, 8, ["complete", "editable"]),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_stepper_item, {
                        complete: _ctx.currentStep > 4,
                        editable: _ctx.currentStep > 4,
                        value: 4,
                        title: "Tools",
                        color: "primary"
                      }, null, 8, ["complete", "editable"]),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_stepper_item, {
                        complete: _ctx.currentStep > 5,
                        editable: _ctx.currentStep > 5,
                        value: 5,
                        title: "Prompt",
                        color: "primary"
                      }, null, 8, ["complete", "editable"]),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_stepper_item, {
                        value: 6,
                        title: "Review"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_stepper_window, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_stepper_window_item, { value: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_form, {
                            modelValue: _ctx.isProviderFormValid,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isProviderFormValid) = $event)),
                            class: "pt-2",
                            autocomplete: "off"
                          }, {
                            default: _withCtx(() => [
                              _cache[16] || (_cache[16] = _createElementVNode("input", {
                                id: "username",
                                autocomplete: "username",
                                type: "text",
                                style: {"display":"none"}
                              }, null, -1)),
                              _cache[17] || (_cache[17] = _createElementVNode("input", {
                                id: "password",
                                autocomplete: "new-password",
                                type: "password",
                                style: {"display":"none"}
                              }, null, -1)),
                              _createVNode(_component_v_combobox, {
                                id: "autofill-off-provider",
                                name: "autofill-off-provider",
                                ref: "providerCombobox",
                                modelValue: _ctx.providerKey,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.providerKey) = $event)),
                                items: _ctx.allProviders,
                                label: "Select a Provider",
                                variant: "outlined",
                                density: "compact",
                                rules: [v => !!v || 'Provider is required'],
                                autocomplete: "off"
                              }, null, 8, ["modelValue", "items", "rules"]),
                              (_ctx.isCustomProvider)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    id: "autofill-off-url",
                                    ref: "providerUrlField",
                                    modelValue: _ctx.providerUrl,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.providerUrl) = $event)),
                                    label: "Provider URL",
                                    variant: "outlined",
                                    density: "compact",
                                    rules: [v => !!v || 'URL is required for custom providers'],
                                    autocomplete: "off"
                                  }, null, 8, ["modelValue", "rules"]))
                                : _createCommentVNode("", true),
                              (!_ctx.providerExists)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 1,
                                    id: "autofill-off-api",
                                    ref: "providerApiKeyField",
                                    modelValue: _ctx.providerApiKey,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.providerApiKey) = $event)),
                                    label: "API Key",
                                    type: "password",
                                    variant: "outlined",
                                    density: "compact",
                                    rules: [v => !_ctx.isCustomProvider && !_ctx.providerExists ? !!v : true || 'API Key is required'],
                                    autocomplete: "off"
                                  }, null, 8, ["modelValue", "rules"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1,
                            __: [16,17]
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_stepper_window_item, { value: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_form, {
                            modelValue: _ctx.isModelFormValid,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isModelFormValid) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio_group, {
                                modelValue: _ctx.modelSetupType,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelSetupType) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_radio, {
                                    label: _ctx.recommendedModelLabel,
                                    value: "recommended"
                                  }, null, 8, ["label"]),
                                  _createVNode(_component_v_radio, {
                                    label: "Enter Model Name",
                                    value: "custom"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              (_ctx.modelSetupType === 'custom')
                                ? (_openBlock(), _createBlock(_component_v_combobox, {
                                    key: 0,
                                    modelValue: _ctx.modelName,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelName) = $event)),
                                    items: _ctx.providerModels,
                                    label: "Model Name (e.g. gpt-4.1, claude-sonnet-4-0)",
                                    variant: "outlined",
                                    density: "compact",
                                    rules: [v => !!v || 'Model name is required']
                                  }, null, 8, ["modelValue", "items", "rules"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_stepper_window_item, { value: 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_form, {
                            modelValue: _ctx.isAgentDetailsFormValid,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isAgentDetailsFormValid) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_textarea, {
                                modelValue: _ctx.agentTask,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.agentTask) = $event)),
                                class: "pt-1",
                                label: "What should this agent do?",
                                placeholder: "e.g., 'Analyze the following rss feeds and summarize the 5 most interesting articles...', or 'The user will provide a public company name or stock ticker, fetch the latest financial data, and provide an analysis...'",
                                variant: "outlined",
                                density: "compact",
                                rows: "5",
                                rules: [v => !!v || 'This field is required']
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_stepper_window_item, { value: 4 }, {
                        default: _withCtx(() => [
                          (_ctx.toolsLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createVNode(_component_v_progress_circular, {
                                  indeterminate: "",
                                  color: "primary"
                                }),
                                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "ml-4 d-inline" }, "Asking model if tools are needed...", -1))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("p", null, "Based on your request, the model recommends " + _toDisplayString(_ctx.toolRecommendation) + ".", 1)
                              ]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_stepper_window_item, { value: 5 }, {
                        default: _withCtx(() => [
                          (_ctx.promptLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(_component_v_progress_circular, {
                                  indeterminate: "",
                                  color: "primary"
                                }),
                                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "ml-4 d-inline" }, "Generating system prompt...", -1))
                              ]))
                            : (_openBlock(), _createBlock(_component_v_textarea, {
                                key: 1,
                                class: "pt-1",
                                modelValue: _ctx.generatedPrompt,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.generatedPrompt) = $event)),
                                label: "Generated System Prompt",
                                variant: "outlined",
                                density: "compact",
                                rows: "10"
                              }, null, 8, ["modelValue"]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_stepper_window_item, { value: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, { class: "pt-2" }, {
                            default: _withCtx(() => [
                              _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-h6" }, "Review your new Agent", -1)),
                              _createVNode(_component_v_divider, { class: "my-2" }),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.agentName,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.agentName) = $event)),
                                label: "Agent Name",
                                variant: "outlined",
                                density: "compact"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.agentDescription,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.agentDescription) = $event)),
                                label: "Agent Description",
                                variant: "outlined",
                                density: "compact"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("p", null, [
                                _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Provider:", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.wizardState.providerKey), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Model:", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.wizardState.modelName), 1)
                              ]),
                              _cache[23] || (_cache[23] = _createElementVNode("p", { class: "mt-2" }, [
                                _createElementVNode("strong", null, "System Prompt:")
                              ], -1)),
                              _createVNode(_component_v_sheet, {
                                border: "",
                                rounded: "",
                                class: "pa-2 system-prompt-sheet"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.wizardState.systemPrompt), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1,
                            __: [22,23]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "blue-darken-1",
                variant: "text",
                onClick: _ctx.closeWizard
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1,
                __: [24]
              }, 8, ["onClick"]),
              (_ctx.currentStep > 1)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "blue-darken-1",
                    variant: "text",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.currentStep--))
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode("Back")
                    ])),
                    _: 1,
                    __: [25]
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                color: "blue-darken-1",
                variant: "text",
                onClick: _ctx.nextStep
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createTextVNode("Next")
                ])),
                _: 1,
                __: [26]
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}